import React from 'react'
import './Error_Toster.css'

const Error_Toster = ({successText}) => {
  
  return (
    <section className='Error_Toster'>
        {/* <div className='img_holder'>
            <img src={process.env.PUBLIC_URL + "/assets/images/other/checkmark.png"} className='inner_img'/>
        </div> */}
        <p className='error_txt'>{successText}</p>
    </section>
  )
}

export default Error_Toster
